import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../util/axiosBaseQuery";

export interface CommercialModel {
  id: string;
  name: string;
  description: string | null;
  price: number;
  recurrence: "monthly" | "yearly";
  locationId: string;
  createdAt: string;
  updatedAt: string;
  archivedAt: string | null;
}

export const commercialModelsApiSlice = createApi({
  reducerPath: "commercialModelsApiSlice",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["CommercialModels"],
  endpoints: (builder) => ({
    getCommercialModelsByLocation: builder.query<CommercialModel[], string>({
      query: (locationId) => ({
        url: `/commercial-models/location/${locationId}`,
      }),
      providesTags: ["CommercialModels"],
    }),
  }),
});

export const { useGetCommercialModelsByLocationQuery } = commercialModelsApiSlice;